import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url, sitename } from '../../../config';

class ContactEmail extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
            ContactMessage: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            phoneNumber: PropTypes.any.isRequired,
        })
    };

    render() {
        const buttonStyle = {
            margin: 0,
            fontFamily: 'Arial',
            padding: '10px 16px',
            textDecoration: 'none',
            borderRadius: '2px',
            border: '1px solid',
            textAlign: 'center',
            verticalAlign: 'middle',
            fontWeight: 'normal',
            fontSize: '18px',
            whiteSpace: 'nowrap',
            background: '#ffffff',
            borderColor: '#0667B3',
            backgroundColor: '#0667B3',
            color: '#ffffff',
            borderTopWidth: '1px',
        };

        const textStyle = {
            color: '#404040',
            backgroundColor: '#F7F7F7',
            fontFamily: 'Arial',
            fontSize: '16px',
            padding: '35px'
        };
        const { content: { ContactMessage, email, name, phoneNumber, logo } } = this.props;

        return (
            <Layout>
                <Header color="#0667B3" backgroundColor="#F7F7F7" logo={logo} />
                <Body textStyle={textStyle}>
                    <div>
                        Hi Admin,
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Ein Nutzer hat folgende Informationen über das Kontaktformular der Website versendet:
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Name: {name}<br /><br />
                        E-Mail Adresse: {email}<br /><br />
                        Kontaktnummer: {phoneNumber}<br /><br />
                        Nachricht:
                        {
                            ContactMessage && (ContactMessage.trim()).split("\n").map(function (item, index) {
                                return (
                                <span key={index}>{item}<br /></span>
                                )
                            })
                        }
                        <br />
                    </div>
                    <EmptySpace height={30} />
                    <div>
                      Vielen Dank, <br />
                        Ihr {sitename} Team
                    </div>
                </Body>
                <Footer />
                <EmptySpace height={20} />
            </Layout>
        );
    }
}

export default ContactEmail;
